import { useEffect, useState } from "react";
import { AcademyService } from "../../../Component/Api/Academy/AcademyService";
import { DataTable } from "../../../Component/Common/Components/DataTable/DataTable";
import { SmallLoading } from "../../../Component/Common/Components/Loading/IntermediateLoading";
import { WebinarSectionItem } from "../../../Component/Model/Dto/Academy";
import { EntriesPerPage } from "../../../Component/Model/Table/Table";
import { WebinarSectionTableMapper } from "./WebinarsSectionColumns";

interface IProps {
    sectionId: number;
}

export const WebinarSectionDataTable = (props: IProps) => {

    const [webinarSectionItemsData, setWebinarSectionItemsData] = useState<WebinarSectionItem.DtoIn[]>([]);
    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [searchValue, setSearchValue] = useState<string>('');
    const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const searchValueChanged = (value: string) => {
        setSearchValue(value);
    }

    const sectionItemsSearchRequest: WebinarSectionItem.SearchRequest = {
        Draw: 2,
        SectionId: props.sectionId,
        PageNumber: pageNumber,
        PageSize: entriesPerPage.defaultValue as number,
        SearchValue: searchValue
    }

    const fetchSectionItems = async () => {
        setIsLoading(true);
        try {
            let response = await AcademyService.SearchWebinarSectionItems(sectionItemsSearchRequest);
            if (response.data){
                setWebinarSectionItemsData(response.data.results);
                setFilteredItemsCount(response.data.filteredItemsCount);
                setTotalItemsCount(response.data.totalItemsCount);    
            }
        }
        catch (error) {
            console.error("Unable to retrieve Training Webinar search results");
        }
        finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchSectionItems();
    }, [entriesPerPage, pageNumber, searchValue]); // eslint-disable-line react-hooks/exhaustive-deps

    const sectionTableData = WebinarSectionTableMapper(webinarSectionItemsData);

    return (
        <>
            <DataTable
                table={sectionTableData}
                entriesPerPage={entriesPerPage}
                pageNumber={pageNumber}
                filteredItemsCount={filteredItemsCount}
                totalItemsCount={totalItemsCount}
                entriesPerPageChanged={entriesPerPageChanged}
                pageNumberChanged={pageNumberChanged}
                isLoading={isLoading}
                canSearch={true}
                searchValueChanged={searchValueChanged}
            ></DataTable>
        </>
    )
}
